import xtend from 'xtend';
import Formatter from '../../../utils/Formatter';
const FORMATS = Formatter.FORMATS

var date = {
    addWeeks: require('date-fns/add_weeks'),
    subWeeks: require('date-fns/sub_weeks'),
    format: require('date-fns/format')
};

function EventsQuery () {
    return {
        startDateTime: date.format( date.subWeeks(new Date(), 2), FORMATS.apiDateFormat),
        stopDateTime: date.format( date.addWeeks(new Date(), 2), FORMATS.apiDateFormat),
        sortBy: 'DESC',
        searchBy: {
            key: null,
            value: null
        }
    };
}

EventsQuery.update = {
    change: function (state, ev) {
        return xtend(state, ev);
    },

    changeSearchKey: function (state, ev) {
        return xtend(state, {
            searchBy: xtend(state.searchBy, {
                key: ev
            })
        });
    }
};

EventsQuery.DEFAULT_QUERY = {
    startDateTime: date.format( date.subWeeks(new Date(), 2), FORMATS.sqlDate),
    stopDateTime: date.format( date.addWeeks(new Date(), 2), FORMATS.sqlDate),
    includePrivate: true,
    sortBy: 'DESC'
};

export default EventsQuery;
